module.exports = flarum.core.compat['utils/throttleDebounce'];